export default __webpack_public_path__ + "static/background_4-2bc53a0a70994cad0f5f602c224ce14b.png";